import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { cityConfig } from "@/config/cityConfig";
import { useMeta } from "@/hooks/useMeta";

export default function DatenschutzPage() {
  useMeta(
    "Datenschutzerklärung | BRIMO Immobilien NRW",
    "Datenschutzerklärung von BRIMO Immobilien NRW gemäß DSGVO."
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Navbar />

      <section className="pt-32 pb-24" data-testid="datenschutz-page">
        <div className="container mx-auto px-4 md:px-6 max-w-3xl">
          <div className="h-0.5 w-12 bg-[#E61D38] mb-6" />
          <h1
            className="text-4xl font-black text-white uppercase tracking-tight mb-10"
            style={{ fontFamily: "Montserrat, sans-serif" }}
          >
            DATENSCHUTZERKLÄRUNG
          </h1>

          <div className="space-y-8 text-gray-400 text-sm leading-relaxed">
            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="text-white font-semibold text-xs uppercase tracking-wider mb-2">
                Allgemeine Hinweise
              </h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                2. Allgemeine Hinweise und Pflichtinformationen
              </h2>
              <h3 className="text-white font-semibold text-xs uppercase tracking-wider mb-2">
                Datenschutz
              </h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den
                gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                3. Verantwortliche Stelle
              </h2>
              <p>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                <br />
                <br />
                {cityConfig.fullCompanyName}
                <br />
                {cityConfig.address.street}
                <br />
                {cityConfig.address.postalCode} {cityConfig.address.city}
                <br />
                <br />
                Telefon: {cityConfig.phoneDisplay}
                <br />
                E-Mail: {cityConfig.email}
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                4. Datenerfassung auf dieser Website
              </h2>
              <h3 className="text-white font-semibold text-xs uppercase tracking-wider mb-2">
                Kontaktformular
              </h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p className="mt-3">
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur
                Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen
                beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven
                Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf
                Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                5. Welche Daten werden erhoben?
              </h2>
              <p>
                Beim Ausfüllen unserer Kontakt- und Anfageformulare erheben wir folgende Daten:
              </p>
              <ul className="list-disc pl-5 mt-3 space-y-1">
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer (optional)</li>
                <li>Angaben zur Immobilie (Typ, Stadtteil, optional)</li>
                <li>Budget (nur bei Käuferanfragen, optional)</li>
                <li>Ihre Nachricht</li>
              </ul>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                6. Wie lange werden Ihre Daten gespeichert?
              </h2>
              <p>
                Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns
                zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der
                Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung
                Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere
                Aufbewahrungsfristen – bleiben unberührt.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                7. Ihre Rechte
              </h2>
              <p>
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
                personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
                Datenverarbeitung sowie ein Recht auf Berichtigung oder Löschung dieser Daten.
                Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich
                jederzeit an uns wenden.
              </p>
              <p className="mt-3">
                Sie haben außerdem das Recht, unter bestimmten Umständen die Einschränkung der
                Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                8. Externe Links und Social Media
              </h2>
              <p>
                Diese Website enthält Links zu externen Diensten (z.B. WhatsApp). Für deren
                Datenschutzpraktiken sind die jeweiligen Anbieter verantwortlich. Wir empfehlen,
                die Datenschutzbestimmungen der jeweiligen Anbieter zu lesen.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-sm uppercase tracking-wider mb-3">
                9. Kontakt für Datenschutzfragen
              </h2>
              <p>
                Bei Fragen zum Datenschutz wenden Sie sich bitte an:
                <br />
                <br />
                {cityConfig.fullCompanyName}
                <br />
                {cityConfig.address.street}, {cityConfig.address.postalCode}{" "}
                {cityConfig.address.city}
                <br />
                E-Mail:{" "}
                <a href={`mailto:${cityConfig.email}`} className="text-[#E61D38]">
                  {cityConfig.email}
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
